<template>
  <div class="active-dialog card">
    <div class="active-dialog__header">
      {{ userData.firstName + ' ' + userData.lastName }}
    </div>
    <el-divider />

    <div
      class="active-dialog__message-list"
      v-if="activeDialogMessages.length > 0"
    >
      <message-preview
        :message-data="message"
        v-for="message in activeDialogMessages"
        :key="message.userMessageId"
      />
    </div>

    <div
      class="active-dialog__empty-text"
      v-if="activeDialogMessages.length === 0"
    >
      No messages in this dialog
    </div>

    <div class="active-dialog__form">
      <message-form
        :user-id="userData.userId"
        @update-data="fetchActiveDialogMessages"
      />
    </div>
  </div>
</template>

<script>
import MessageForm from '@/components/messages/MessageForm.vue';
import MessagePreview from '@/components/messages/MessagePreview.vue';

import { getMessageFromUser } from '@/api/messages.js';
import { showMessage } from '@/utils/messages.js';

export default {
  name: 'ActiveDialog',
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  components: { MessageForm, MessagePreview },
  data() {
    return {
      activeDialogMessages: [],
    };
  },
  methods: {
    async fetchActiveDialogMessages() {
      const { userId } = this.userData;
      const { data, success } = await getMessageFromUser({ userId });

      if (success) {
        this.activeDialogMessages = data.items;
      }
    },
  },
  created() {
    this.fetchActiveDialogMessages();
  },
  watch: {
    userData() {
      this.fetchActiveDialogMessages();
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.active-dialog {
  &__header {
    margin-bottom: -10px;
  }

  &__message-list {
    height: auto;
    max-height: 80vh;
    overflow-y: scroll;

    @include from('xl') {
      max-height: 50vh;
    }
  }

  &__empty-text {
  }

  &__form {
  }
}

.message {
  margin-bottom: var(--global-dimension-size-250);

  &__user {
    display: flex;
    font-size: var(--global-dimension-size-200);
  }
  &__user-link {
    display: flex;
    align-items: center;
    margin-right: var(--global-dimension-size-125);
  }
  &__user-avatar {
    margin-right: var(--global-dimension-size-125);
  }
  &__user-name {
    color: var(--color-primary-400);
    margin-bottom: var(--global-dimension-size-125);
  }
  &__date {
    color: var(--color-gray-700);
  }
  &__text {
  }
}
</style>
